import { StanButton, StanModal } from '@/components';

interface DeleteFunnelPageModalProps {
    isOpen: boolean;
    onClose: () => void;
    pageTitle: string;
    isDeleting: boolean;
    onConfirm: () => void;
}

/**
 * Confirmation modal for deleting a funnel page.
 * Mirrors Vue's DeleteProductModal behavior for funnel pages.
 */
export const DeleteFunnelPageModal = ({
    isOpen,
    onClose,
    pageTitle,
    isDeleting,
    onConfirm,
}: DeleteFunnelPageModalProps) => {
    return (
        <StanModal id='delete-funnel-page-modal' size='sm' isOpen={isOpen} onClose={onClose} title='Delete Page'>
            <div className='flex flex-col gap-4'>
                <p className='text-body-md text-gray text-center'>
                    Are you sure you want to delete <strong className='text-dark'>{pageTitle}</strong>? This action
                    cannot be undone.
                </p>
                <div className='flex w-full gap-1 pt-2 max-sm:flex-col sm:gap-2'>
                    <StanButton name='cancel-delete-page' variant='outline' onClick={onClose} className='w-full'>
                        Cancel
                    </StanButton>
                    <StanButton
                        name='confirm-delete-page'
                        color='destructive'
                        onClick={onConfirm}
                        disabled={isDeleting}
                        className='w-full'
                    >
                        {isDeleting ? 'Deleting...' : 'Delete'}
                    </StanButton>
                </div>
            </div>
        </StanModal>
    );
};
